/* HALE core — Phase 1 of the 2026-09-08 rewrite.
   One file, loaded with `defer` from <head> right after snippets/hale-config.liquid.

   Provides window.HALE.*:
     formatMoney / esc / plural / track / copyText     — shared helpers (mirror hale-money.liquid)
     cart   — the ONLY code that talks to /cart*.js. Serialised mutations, one
              in-flight request, state seeded from Liquid (HALE.initialCart).
              Emits `hale:cart` {cart, reason, count, added} on document.
     layers — the ONLY owner of scroll-lock / Escape / focus for drawers,
              panels and modals. Emits `hale:layer` {id, open, count}.
     ui.toast(msg, {action, onAction, kind, duration}) — the one toast.
     ready(fn) — runs fn once core is up (queued by hale-config before that).
     feature(name, init) — registers an init that runs on DOMContentLoaded
              and again on shopify:section:load.

   Rules for everything else in the theme: never fetch /cart.js yourself,
   never write body.style.overflow, never add a keydown Escape handler for a
   panel — subscribe to `hale:cart`, call HALE.layers.open/close. */
(function(){
  'use strict';
  var H = window.HALE = window.HALE || {};
  var doc = document;

  function on(evt, fn, opts){ doc.addEventListener(evt, fn, opts || false); return fn; }
  function emit(evt, detail){ doc.dispatchEvent(new CustomEvent(evt, { detail: detail || {} })); }
  H.on = on; H.emit = emit;

  /* ---------------- helpers ---------------- */
  var NBSP = String.fromCharCode(160), UAH = String.fromCharCode(8372), MINUS = String.fromCharCode(8722);
  H.formatMoney = function(cents){
    var n = Math.round(Number(cents) || 0), abs = Math.abs(n);
    var whole = Math.floor(abs / 100), frac = abs % 100;
    var s = String(whole).replace(/\B(?=(\d{3})+(?!\d))/g, NBSP);
    if(frac) s += ',' + (frac < 10 ? '0' : '') + frac;
    return (n < 0 ? MINUS : '') + s + NBSP + UAH;
  };
  H.esc = function(s){
    return String(s == null ? '' : s).replace(/[&<>"']/g, function(c){
      return { '&':'&amp;', '<':'&lt;', '>':'&gt;', '"':'&quot;', "'":'&#39;' }[c];
    });
  };
  H.plural = function(n, one, few, many){
    var a = n % 10, b = n % 100;
    if(a === 1 && b !== 11) return one;
    if(a >= 2 && a <= 4 && (b < 12 || b > 14)) return few;
    return many;
  };
  H.track = function(name, params){
    params = params || {};
    try{ window.dataLayer = window.dataLayer || []; window.dataLayer.push(Object.assign({ event: name }, params)); }catch(e){}
    try{ if(typeof window.gtag === 'function') window.gtag('event', name, params); }catch(e){}
    try{ if(typeof window.fbq === 'function') window.fbq('trackCustom', name, params); }catch(e){}
    /* 2026-09-21: та сама подія — у систему подій Shopify (Customer events). Кастомний
       піксель у Settings → Customer events підписується на неї
       (analytics.subscribe('hale_chat_widget_open', …)) і пересилає в GA4 —
       на сторінці немає ні gtag, ні GTM, тому інакше клік по бульбашці Дар'ї
       ніде не рахувався. Префікс hale_, щоб не плутати з подіями Shopify. */
    try{ if(window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') window.Shopify.analytics.publish('hale_' + name, params); }catch(e){}
  };
  /* execCommand first: navigator.clipboard rejects asynchronously and the click
     gesture is gone by then (measured in this theme, see hale-modals history). */
  H.copyText = function(text){
    var ok = false;
    try{
      var ta = doc.createElement('textarea');
      ta.value = text; ta.contentEditable = 'true'; ta.readOnly = false;
      ta.setAttribute('aria-hidden', 'true');
      ta.style.cssText = 'position:fixed; top:0; left:-9999px; opacity:0';
      doc.body.appendChild(ta);
      var range = doc.createRange(); range.selectNodeContents(ta);
      var sel = window.getSelection(); sel.removeAllRanges(); sel.addRange(range);
      ta.setSelectionRange(0, 999999);
      ok = doc.execCommand('copy');
      sel.removeAllRanges(); ta.remove();
    }catch(e){}
    try{ if(navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(text).catch(function(){}); }catch(e){}
    return ok;
  };
  /* legacy names still used by inline scripts until Phase 2 */
  window.haleTrack = H.track;
  window.haleCopyText = H.copyText;

  function json(url, opts){
    opts = opts || {};
    opts.headers = Object.assign({ 'Accept': 'application/json' }, opts.headers || {});
    return fetch(url, opts).then(function(r){
      return r.text().then(function(t){
        var j; try{ j = t ? JSON.parse(t) : {}; }catch(e){ j = {}; }
        if(!r.ok){
          var err = new Error(j.description || j.message || ('HTTP ' + r.status));
          err.status = r.status; err.body = j; throw err;
        }
        return j;
      });
    });
  }

  /* ---------------- cart store ---------------- */
  var R = H.routes || {};
  var CART = (R.cart || '/cart') + '.js';
  var state = H.initialCart || null;
  var chain = Promise.resolve();
  function serial(fn){ var p = chain.then(fn, fn); chain = p.catch(function(){}); return p; }
  function set(c, reason, extra){
    if(!c || typeof c.item_count === 'undefined') return state;
    state = c;
    emit('hale:cart', Object.assign({ cart: c, reason: reason, count: H.cartCount(c) }, extra || {}));
    return c;
  }
  H.cart = {
    get: function(){ return state; },
    count: function(){ return state ? H.cartCount(state) : 0; },
    freeShipLeft: function(){ return Math.max(0, (H.freeShip || 0) - (state ? state.items_subtotal_price : 0)); },
    refresh: function(reason){
      return serial(function(){ return json(CART).then(function(c){ return set(c, reason || 'refresh'); }); });
    },
    add: function(payload, meta){
      meta = meta || {};
      return serial(function(){
        var opts = { method: 'POST' };
        if(payload instanceof FormData){ opts.body = payload; }
        else { opts.headers = { 'Content-Type': 'application/json' }; opts.body = JSON.stringify(payload); }
        return json((R.cartAdd || '/cart/add') + '.js', opts).then(function(added){
          return json(CART).then(function(c){ return set(c, 'add', { added: added, source: meta.source || '' }); });
        });
      });
    },
    change: function(key, quantity){
      return serial(function(){
        return json((R.cartChange || '/cart/change') + '.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: key, quantity: quantity })
        }).then(function(c){ return set(c, quantity === 0 ? 'remove' : 'change'); });
      });
    },
    update: function(updates){
      return serial(function(){
        return json((R.cartUpdate || '/cart/update') + '.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ updates: updates })
        }).then(function(c){ return set(c, 'update'); });
      });
    },
    /* order note (cart page) — reason 'note', so subscribers that re-render
       the whole page can skip it */
    note: function(text){
      return serial(function(){
        return json((R.cartUpdate || '/cart/update') + '.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ note: text })
        }).then(function(c){ return set(c, 'note'); });
      });
    }
  };

  /* Delegated add-to-cart. Every Hale form that posts to /cart/add goes through
     the store; no stopImmediatePropagation, so other listeners still run.
     Opt out with data-hale-native on the form. */
  on('submit', function(e){
    var f = e.target;
    if(!f || !f.matches || !f.matches('form[action*="/cart/add"]')) return;
    if(f.hasAttribute('data-hale-native')) return;
    if(!f.closest('.hale') && !f.hasAttribute('data-hale-add')) return;
    /* НЕ f.id: коли селект name="id" стоїть поза формою і прив'язаний атрибутом
       form="pdpForm", він стає іменованим контролом форми, і f.id повертає сам
       <select>, а не рядок. Селектор тоді ніколи не збігався, ядро виходило, і
       PDP робив нативний POST з редиректом на /cart (аудит 2026-09-10, B01). */
    var fid = f.getAttribute('id');
    var hasId = f.querySelector('[name="id"]') || (fid && doc.querySelector('[name="id"][form="' + fid + '"]'));
    if(!hasId) return;
    e.preventDefault();
    /* подвійний submit (липка кнопка + Enter, два швидкі тапи) — поки запит у польоті, ігноруємо */
    if(f.getAttribute('data-hale-busy') === '1') return;
    f.setAttribute('data-hale-busy', '1');
    var btn = f.querySelector('[type="submit"]');
    if(btn){ btn.disabled = true; btn.classList.add('busy'); }
    H.cart.add(new FormData(f), { source: f.getAttribute('data-hale-source') || 'form' })
      .catch(function(err){ H.ui.toast((err && err.message) || 'Не вдалося додати в кошик', { kind: 'error' }); })
      .then(function(){ f.removeAttribute('data-hale-busy'); if(btn){ btn.disabled = false; btn.classList.remove('busy'); } });
  }, true);

  /* ---------------- layers ---------------- */
  var layers = [];
  function lockUpdate(){ doc.documentElement.classList.toggle('hale-lock', layers.length > 0); }
  function focusables(el){
    return el.querySelectorAll('a[href],button:not([disabled]),input:not([disabled]):not([type="hidden"]),select:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex="-1"])');
  }
  H.layers = {
    open: function(id, el, opts){
      opts = opts || {};
      this.close(id, { silent: true });
      layers.push({ id: id, el: el || null, opts: opts, prev: doc.activeElement });
      lockUpdate();
      if(el){
        el.classList.add('is-open');
        if(opts.focus !== false){
          setTimeout(function(){
            var f = opts.focusEl || focusables(el)[0];
            if(f && f.focus) try{ f.focus({ preventScroll: true }); }catch(e){}
          }, 60);
        }
      }
      emit('hale:layer', { id: id, open: true, count: layers.length });
    },
    close: function(id, o){
      o = o || {};
      var i = -1;
      for(var k = layers.length - 1; k >= 0; k--){ if(layers[k].id === id){ i = k; break; } }
      if(i < 0) return false;
      var L = layers.splice(i, 1)[0];
      lockUpdate();
      if(L.el) L.el.classList.remove('is-open');
      if(!o.silent){
        if(L.opts.onClose) try{ L.opts.onClose(o.reason || 'api'); }catch(e){}
        if(L.prev && L.prev.focus && o.reason !== 'navigate') try{ L.prev.focus({ preventScroll: true }); }catch(e){}
      }
      emit('hale:layer', { id: id, open: false, count: layers.length });
      return true;
    },
    closeTop: function(reason){
      if(!layers.length) return false;
      return this.close(layers[layers.length - 1].id, { reason: reason || 'escape' });
    },
    isOpen: function(id){ return layers.some(function(L){ return L.id === id; }); },
    isEmpty: function(){ return layers.length === 0; },
    top: function(){ return layers.length ? layers[layers.length - 1].id : null; }
  };
  on('keydown', function(e){
    if(!layers.length) return;
    if(e.key === 'Escape'){ e.preventDefault(); H.layers.closeTop('escape'); return; }
    if(e.key !== 'Tab') return;
    var L = layers[layers.length - 1];
    if(!L.el || L.opts.trap === false) return;
    var f = focusables(L.el); if(!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if(e.shiftKey && doc.activeElement === first){ e.preventDefault(); last.focus(); }
    else if(!e.shiftKey && doc.activeElement === last){ e.preventDefault(); first.focus(); }
    else if(!L.el.contains(doc.activeElement)){ e.preventDefault(); first.focus(); }
  });

  /* ---------------- toast ---------------- */
  var toastEl = null, toastTimer = null;
  H.ui = {
    toast: function(msg, opts){
      opts = opts || {};
      if(!toastEl){
        toastEl = doc.createElement('div');
        toastEl.className = 'hale-toast';
        toastEl.setAttribute('role', 'status');
        toastEl.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M5 12l4 4L19 6"/></svg>'
          + '<div><b></b><button type="button" class="hale-toast__act" hidden></button></div>';
        doc.body.appendChild(toastEl);
        toastEl.querySelector('.hale-toast__act').addEventListener('click', function(){
          var fn = toastEl._act; H.ui.hideToast(); if(fn) fn();
        });
      }
      toastEl.classList.toggle('is-error', opts.kind === 'error');
      toastEl.querySelector('b').textContent = msg;
      var act = toastEl.querySelector('.hale-toast__act');
      if(opts.action){ act.textContent = opts.action; act.hidden = false; toastEl._act = opts.onAction || null; }
      else { act.hidden = true; toastEl._act = null; }
      toastEl.classList.add('is-on');
      clearTimeout(toastTimer);
      toastTimer = setTimeout(H.ui.hideToast, opts.duration || 3400);
    },
    hideToast: function(){ if(toastEl) toastEl.classList.remove('is-on'); }
  };

  /* ---------------- lifecycle ---------------- */
  var features = [], booted = false;
  function run(f){ try{ f.init(doc); }catch(err){ if(window.console) console.error('[HALE] feature ' + f.name, err); } }
  H.feature = function(name, init){ var f = { name: name, init: init }; features.push(f); if(booted) run(f); };
  function boot(){
    if(booted) return;
    booted = true;
    H.core = true;
    features.forEach(run);
    var q = H._q || []; H._q = [];
    q.forEach(function(fn){ try{ fn(); }catch(err){ if(window.console) console.error('[HALE] ready', err); } });
    emit('hale:ready');
  }
  if(doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', boot); else boot();
  on('shopify:section:load', function(){ features.forEach(run); });
})();